import { Box } from "@/components/ui/box";
import { FormControl, FormControlLabel, FormControlLabelText } from "@/components/ui/form-control";
import { Input, InputField } from "@/components/ui/input";
import { Text } from "@/components/ui/text";
import { formatPhoneNumber, getPhoneDigits } from "@/utils/formatPhoneNumber";
import { useT } from "@transifex/react";
import { ContactType } from "ipctg-inflow-types/InFlowEnums";
import { Pressable } from "react-native";

type ContactInputProps = {
  mode: ContactType;
  value: Record<ContactType, string>;
  onChange: (value: string) => void;
  onUpdateMode: (mode: ContactType) => void;
  errorMessage: string;
  clearError: () => void;
};

const ContactInput: React.FC<ContactInputProps> = ({ mode, value, onChange, onUpdateMode, errorMessage, clearError }) => {
  const t = useT();

  return (
    <FormControl isInvalid={!!errorMessage} key="contact-input">
      <Box className="gap-[6px]">
        <FormControlLabel className="flex items-center justify-between mb-0">
          <FormControlLabelText className="text-typography-900 text-[14px] font-[600] leading-[20px] align-middle">
            {mode === ContactType.Email ? t("Email Address") : t("Phone Number")}
          </FormControlLabelText>
          <Pressable onPress={() => onUpdateMode(mode === ContactType.Email ? ContactType.Phone : ContactType.Email)}>
            <Text className="text-typography-900 text-[14px] font-[400] leading-[20px] align-middle underline decoration-solid decoration-[0%] decoration-thickness-[0%]">
              {mode === ContactType.Email ? t("Phone Instead?") : t("Email Instead?")}
            </Text>
          </Pressable>
        </FormControlLabel>
        <Input
          className={`h-[52px] pt-[8px] pb-[8px] pl-[4px] gap-[8px] rounded-[6px] border-[1px] ${errorMessage ? "bg-error-50 border-error-400" : "bg-background-100 border-secondary-700"}`}
        >
          <InputField
            className="text-typography-900 text-[16px] font-[400] leading-[22px] align-middle placeholder-text-typography-900 placeholder-opacity-50"
            placeholder={mode === ContactType.Email ? "hello@email.com" : "+1 (123) 456-7890"}
            placeholderTextColor="text-typography-900"
            keyboardType={mode === ContactType.Email ? "email-address" : "phone-pad"}
            autoCapitalize="none"
            value={mode === ContactType.Email ? value[mode] : formatPhoneNumber(value[mode])}
            onChangeText={(value) => onChange(mode === ContactType.Email ? value : getPhoneDigits(value))}
            onFocus={() => clearError()}
          />
        </Input>
        {errorMessage && <Text className="text-error-100 text-[14px] leading-[20px]">{errorMessage}</Text>}
      </Box>
    </FormControl>
  );
};

export default ContactInput;
